<template>
  <div class="container">
    <div class="features text-center">
      <div
        class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
      >
        <h2 class="title">Contacto</h2>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-33 md-small-size-100">
          <div class="info">
            <div class="icon icon-info">
              <md-icon>pin_drop</md-icon>
            </div>
            <h4 class="info-title">Dirección</h4>
            <a  class="tituloH4" href="https://www.google.com/maps/dir/19.440647,-99.2231394/brisas+del+lago+valle+de+bravo/@19.3768688,-100.224983,9z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x85cd63873cdce2f1:0xed33db705faf17dd!2m2!1d-100.1352813!2d19.220582">Privada Rincon de las Estrellas S/N, El Arco San Gaspar, 51200 Valle de Bravo, Méx.</a>
          </div>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <div class="info">
            <div class="icon icon-info">
              <md-icon>phone</md-icon>
            </div>
            <h4 class="info-title">Telefonos Valle de Bravo</h4>
            <h4>Oficina</h4>
            <a href="tel:7262665184" class="tituloH4">726 266 5184</a>
            <h4>Whatsapp</h4>
            <a href="https://api.whatsapp.com/send?phone=+525619873894" class="tituloH4">5619873894</a>
          </div>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <div class="info">
            <div class="icon icon-info">
              <md-icon>mail</md-icon>
            </div>
            <h4 class="info-title">Correo electrónico</h4>
            <a href="mailto:reservaciones@brisasdellago.com.mx" class="tituloH4"
              >reservaciones@brisasdellago.com.mx</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.tituloH4 {
  font-size: 18px;
  color: black;
}
</style>